import { useMutation } from 'urql'

const LOGIN_MUTATION = `
  mutation Login($email: String!, $pass: String!) {
    login(input: { email: $email, password: $pass }) {
      accessToken
    }
  }
`

export const LogIn = () => {
  const [, executeMutation] = useMutation(LOGIN_MUTATION)
  return (variables) => executeMutation(variables)
}

